import { BaseModel, IPhoneNumber, PhoneNumber } from '@red/data-access';
import { Expose, Type } from 'class-transformer';
import { IDistrict } from '../interfaces/district.interface';
import { INationality } from '../interfaces/nationality.interface';
import { IProjectTransactionBuyerInfo } from '../interfaces/project-transaction-buyer-info.interface';
import { DistrictModel } from './district.model';
import { NationalityModel } from './nationality.model';
export class ProjectTransactionBuyerInfoModel extends BaseModel implements IProjectTransactionBuyerInfo{

  @Expose()
  remark!: string;

}
